<template>
  <div class="newsList-body-box">
    <div class="newsList-top-img banCopy">
      <img src="../image/AWXZNTHK02356789_1594113221.png" />
    </div>

    <div class="newsList-content-box">
      <ul class="newsList-content-list list-unstyled col-11 col-lg-7">
        <li
          class="newsList-content-list-item"
          v-for="(item, index) in newsListArr"
          :key="index"
          @click="gotoEssay(item.id,item.content, item.title, item.date, item.author)"
        >
          <div class="newsList-content-list-item-time col-lg-1">
            <h4 class="newsList-content-list-item-time-year">
              {{ item.year }}
            </h4>
            <h6 class="newsList-content-list-item-time-day">{{ item.day }}</h6>
          </div>
          <div class="newsList-content-list-item-content col-10 col-lg-10">
            <h4 class="newsList-content-list-item-content-title banCopy hand">
              {{ item.title }}
            </h4>
            <h6
              class="newsList-content-list-item-content-text d-none d-lg-block"
            >
              {{ item.outline }}
            </h6>
          </div>
        </li>
        <li class="pageNumber-box banCopy" v-if="pageNumbar != 0">
          <ul
            class="
              list-unstyled list-group list-group-horizontal list-inline
              pageNumber-list
            "
          >
            <li>
              <button class="prev-but" :class="{disabled:prev==true}" :disabled="prev" @click="prevFunction()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  />
                </svg>
              </button>
            </li>
            <li
              v-for="(item, index) in pageNumbar"
              :key="index"
              class="pagerNumber hand"
              :class="{
                active: currentNumber == item,
                changeColor: changeColorBl == item,
              }"
              @click="pagerNumberFun($event)"
              @mousemove="hoverItem($event)"
              @mouseout="hoverOut($event)"
            >
              {{ item }}
            </li>
            <li>
              <button class="next-but" :class="{disabled:next==true}" :disabled="next" @click="nextFunction()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    currentNumber() {
      var a = 0;
      this.newsListArr = [];
      if (this.currentNumber == this.pageNumbar) {
        var strat = (Number(this.currentNumber) - 1) * Number(this.number);
        var cease = this.storageList.length;
        // console.log(strat + "  " + cease)
        for (var i = strat; i < cease; i++) {
          // console.log(i)
          this.newsListArr[a] = this.storageList[i];
          a++;
        }
      } else {
        var strat = (Number(this.currentNumber) - 1) * Number(this.number);
        var cease = Number(this.number) * Number(this.currentNumber);
        // console.log(strat + "  " + cease)
        for (var i = strat; i < cease; i++) {
          this.newsListArr[a] = this.storageList[i];
          a++;
        }
      }
    },
    $route: function (to, from) {
      this.newsListArr = [];
      this.pageNumbar = 0;
      if (this.$route.query.serchString != undefined) {
        this.Post(
          "http://demoapi.hkjt.cn/pages/searchNews.php?serchString=" +
            this.$route.query.serchString
        );
      } else {
        this.Post("http://demoapi.hkjt.cn/pages/newList.php");
      }
    },
  },
  mounted() {
    document.title="杭开集团-新闻列表";

    this.$router.go;
    if (this.$route.query.serchString != undefined) {
      this.Post(
        "http://demoapi.hkjt.cn/pages/searchNews.php?serchString=" +
          this.$route.query.serchString
      );
    } else {
      this.Post("http://demoapi.hkjt.cn/pages/newList.php");
    }
  },
  methods: {
    Post(url) {
      this.axios
        .get(url)
        .then((res) => {
          if (res.data.length == 0) {
            this.pageNumbar = 0;
          } else {
            this.storageList = [];
            this.pageNumbar = 0;
            this.newsListArr = [];
            //console.log(res.data)
            this.storageList = res.data;
            this.pageNumbar = Math.ceil(this.storageList.length / this.number);

            var a = 0;
            if (res.data.length < this.number) {
              for (var i = 0; i < res.data.length; i++) {
                this.newsListArr[a] = this.storageList[i];
                a++;
              }
            } else {
              for (var i = 0; i < this.number; i++) {
                this.newsListArr[a] = this.storageList[i];
                a++;
              }
            }
            //console.log(this.newsListArr)
          }
        })
        .catch((e) => {
          if (e.response) {
            //请求已发出，服务器返回状态码不是2xx。
            console.info(e.response.data);
            console.info(e.response.status);
            console.info(e.response.headers);
          } else if (e.request) {
            // 请求已发出，但没有收到响应
            // e.request 在浏览器里是一个XMLHttpRequest实例，
            // 在node中是一个http.ClientRequest实例
            console.info(e.request);
          } else {
            //发送请求时异常，捕捉到错误
            console.info("error", e.message);
          }
          console.info(e.config);
        });
    },
    gotoEssay(id,content, title, date, author) {
      this.$router.push({
        name: "essay",
        query: {
          id: id,
          // content: content,
          // title: title,
          // date: date,
          // author: author,
          type: "news",
        },
      });
    },
    prevFunction() {
      var num = this.currentNumber;
      num--;
      if (num == 1) {
        this.currentNumber = 1;
        this.prev = true;
      } else {
        this.currentNumber = num;
      }
      if (num != this.pageNumbar) {
        this.next = false;
      }
    },
    nextFunction() {
      var num = this.currentNumber;
      num++;
      if (num == this.pageNumbar) {
        this.currentNumber = this.pageNumbar;
        this.next = true;
      } else {
        this.currentNumber = num;
      }
      if (num != 1) {
        this.prev = false;
      }
    },
    pagerNumberFun(e) {
      var numbar = e.currentTarget.innerHTML;
      this.changeColorBl = 0;
      this.currentNumber = numbar;
    },
    hoverItem(e) {
      var numbar = e.currentTarget.innerHTML;
      if (numbar != this.currentNumber) {
        this.changeColorBl = numbar;
      }
    },
    hoverOut(e) {
      this.changeColorBl = 0;
    },
  },
  data() {
    return {
      prev: true,
      next: false,
      changeColorBl: 0,

      storageList: [], //存放的内容
      newsListArr: [], //显示的内容
      pageNumbar: 1,
      number: 12, //每页显示12个
      currentNumber: 1, //当前页码
    };
  },
};
</script>

<style scoped>
.disabled{
    color: rgb(192, 196, 204) !important;
}

.prev-but,
.next-but {
  font-family: Arial;
}

.pagerNumber,
.prev-but,
.next-but {
  color: rgb(48, 49, 51);
  font-size: 0.8125rem;
}

.newsList-top-img {
  width: 100vw;
  /* margin-top: 15rem; */
}

.newsList-top-img > img {
  width: 100%;
}

.newsList-content-list-item-time-year {
  width: 100%;
  letter-spacing: 0.05rem;
  font-size: 1.25rem;
  color: rgb(102, 102, 102) !important;
}

.newsList-content-list-item-time-year,
.newsList-content-list-item-content-title {
  /* font-size: 1.2rem; */
  padding-bottom: 0.3rem;
}

.newsList-content-list-item-content-title {
  white-space: normal;
  font-size: 1rem;
  color: rgb(54, 54, 54);
}

.newsList-content-list-item-content-title:hover {
  color: #237fef;
}

.newsList-content-list-item-content-text {
  font-size: 1rem;
  color: rgb(152, 152, 152);
}

.newsList-content-list-item-time-day {
  white-space: nowrap;
  font-size: 0.9375rem;
  color: rgb(102, 102, 102);
}

@media screen and (max-width: 991px) {
  .newsList-content-list-item-time-year,
  .newsList-content-list-item-content-title {
    font-size: 1rem;
  }

  .newsList-content-list-item-time-day,
  .newsList-content-list-item-content-text {
    font-size: 0.8rem;
  }
}

.newsList-content-list {
  border-top: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.newsList-content-list-item {
  padding: 2rem 0 0 0;
  height: auto;
}

.newsList-content-list-item-time {
  float: left;
}

.newsList-content-list-item-content {
  float: left;
  border-bottom: 1px solid #e8e8e8;
  padding-left: 1rem;
  padding-bottom: 1rem;
  height: 100%;
}

.newsList-content-box {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5rem 0;
}

.pageNumber-box {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  margin-top: 2rem;
}

@media screen and (max-width: 991px) {
  .newsList-content-box {
    margin: 2rem 0 5rem 0;
  }
}
</style>